import React, { createContext, useContext, useState } from 'react';
import AuthModal from '../components/AuthModal';

const AuthModalContext = createContext();

export function AuthModalProvider({ children }) {
  const [visible, setVisible] = useState(false);

  return (
    <AuthModalContext.Provider value={{ showAuthModal: () => setVisible(true) }}>
      {children}
      {visible && <AuthModal onClose={() => setVisible(false)} />}
    </AuthModalContext.Provider>
  );
}

export function useAuthModal() {
  return useContext(AuthModalContext);
}
